import { useGetExItemsAllSuspense } from '@/context/services/ex_item/ExItem.service';
import { ExItem, ExItemSettingAlertKindEnum } from 'ap-openapi';
import { useCallback } from 'react';

export function useGetExItem() {
  const exItemsList = useGetExItemsAllSuspense();
  const getDrExciseFromExItem = useCallback(
    (exItemId: ExItem['id']) => {
      if (!exItemId) return undefined;

      const exItem = exItemsList.find(({ id }) => id === exItemId);
      return exItem
        ? {
            id: exItem.dr_excise_id,
            display_name: exItem.display_name,
          }
        : undefined;
    },
    [exItemsList]
  );
  const getDrExciseIdFromExItem = useCallback(
    (exItemId: ExItem['id']) => {
      return getDrExciseFromExItem(exItemId)?.id;
    },
    [getDrExciseFromExItem]
  );

  const getAlertKind = useCallback(
    (exItemId: ExItem['id']) => {
      if (!exItemId) return undefined;

      const exItem = exItemsList.find(({ id }) => id === exItemId);
      return exItem
        ? {
            deptId: exItem.setting?.dept_alert_kind,
            projectCodeId: exItem.setting?.project_alert_kind,
            memo: exItem.setting?.memo_alert_kind,
            hasWithholdingIncomeTax:
              exItem.setting?.withholding_income_tax_alert_kind,
          }
        : {
            deptId: ExItemSettingAlertKindEnum.ignored,
            projectCodeId: ExItemSettingAlertKindEnum.ignored,
            memo: ExItemSettingAlertKindEnum.ignored,
            hasWithholdingIncomeTax: ExItemSettingAlertKindEnum.ignored,
          };
    },
    [exItemsList]
  );

  return { getDrExciseIdFromExItem, getDrExciseFromExItem, getAlertKind };
}
